var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPiano(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9365 21.5217V2.3913C23.9365 1.07274 22.8637 0 21.5452 0H20.1104H19.6321H16.7626H16.2843H14.3713H13.893H11.0234H10.5452H8.63213H8.15387H5.28431H4.80605H2.41474C1.09618 0 0.0234375 1.07274 0.0234375 2.3913V21.5217C0.0234375 22.8403 1.09618 23.913 2.41474 23.913H21.5452C22.8637 23.913 23.9365 22.8403 23.9365 21.5217ZM6.24083 22.9565H2.41474C1.6237 22.9565 0.979959 22.3128 0.979959 21.5217V2.3913C0.979959 1.60026 1.6237 0.956522 2.41474 0.956522H4.80605V15.3043H6.24083V22.9565ZM7.19735 22.9565H11.98V15.3043H10.5452V0.956522H8.63213V15.3043H7.19735V22.9565ZM17.7191 22.9565H12.9365V15.3043H14.3713V0.956522H16.2843V15.3043H17.7191V22.9565ZM20.1104 15.3043H18.6756V22.9565H21.5452C22.3362 22.9565 22.98 22.3128 22.98 21.5217V2.3913C22.98 1.60026 22.3362 0.956522 21.5452 0.956522H20.1104V15.3043Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiano);
export default __webpack_public_path__ + "static/media/piano.e5e24f85.svg";
export { ForwardRef as ReactComponent };